/* eslint-disable complexity */
/* eslint-disable max-lines */
import { Inject, Injectable, Renderer2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { CssClass, KngHeaderNavMenuOption, KngHeaderNavStateItem, ModalState, KngShellState } from 'kinetic-angular';
import { EnvironmentRef } from '../../../../src/environments/interfaces';
import { BehaviorSubject, concatMap, Observable, Observer, Subject, tap, firstValueFrom } from 'rxjs';
import { ApiResponse } from '../../definitions/api-response.interface';
import { expEnvironmentRef } from '../../injection-tokens/environment.injection-token';
import { AemApiService } from '../../services/api/api.aem.service';
import { ApiService } from '../../services/api/api.service';
import { LoggerService } from '../../services/logger/logger.service';
import { SharedService } from '../../services/shared/shared.service';
import { Banner } from '../myfleet/sub-modules/equipment-detail';
import { ShellFactory } from './shell.factory';
import { AemLabelsPolicy, AemLabelsTnC, AlertBannerList, AssignedRoles, BusinessAccountRegistrationSuccess, BusinessAccountRegistrationSuccessLabels, CustomerState, HeaderAlertBanner, HeaderNavResponse, MultipleRoleOptions, MultipleRoleToastMsg, ShellData, SubmitTnc, SwitchAccountPayload, SwitchRole, UserPreferncePayload } from './shell.interface';
import { get as lodashGet } from 'lodash';
import { LoggedInUser, Image } from '../../services/shared/shared-interface';
import { Icons, ModalButtonId, TermsAndConditionPrivacyPolicyInfoBannerText } from '../../services/shared/shared-enums';
import { SharedApiService } from '../../services/shared/shared-api-call.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { Location } from 'projects/kinetic-angular/src/lib/components/nav/header-nav/definitions/kng-header-nav.interface';
import { ToastrService } from 'ngx-toastr';
import { AlertBanner, KngBannerState, ReviewListBannerState } from 'projects/kinetic-angular/src/lib/components/banner/definitions';
import { CustomerSupportAemLabel } from '../customer-support/definition/customer-support.interface';
import { urlPaths } from '../../services/api/api.url';
import { AuthService } from '../auth';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable({ providedIn: 'root' })
export class ShellService
{
	private readonly state$: BehaviorSubject<KngShellState> = new BehaviorSubject<KngShellState>(ShellFactory.buildState());
	customerSupportData: CustomerState = ShellFactory.buildCustomerState();
	endSessionModalState: ModalState = ShellFactory.buildEndSessionModal();
	inactiveSessionModalState: ModalState = ShellFactory.buildInactiveSessionModal();
	multipleRoleModalState: ModalState = ShellFactory.buildMultipleRoleModal();

	bannerState: KngBannerState = ShellFactory.buildBannerState();
	termsAndConditionAEMlabels: AemLabelsTnC = ShellFactory.buildAEMlist();
	policyAEMlabels: AemLabelsPolicy = ShellFactory.buildAEMlistPolicy();
	termsAndCondition : ModalState = ShellFactory.buildTnC();
	policyState: ModalState = ShellFactory.buildPolicy();
	shouldLoadPage$ = new Subject<boolean>();
	isDirty$ = new Subject<boolean>();
	aemBaseUrl: string = this.environmentRef.aemBaseUrl;
	shellStateHeaderNavMapperObject: Array<KngHeaderNavStateItem> = ShellFactory.buildState().header;
	reviewListBannerState: ReviewListBannerState = ShellFactory.reviewListBannerState();
	notificationPath: Image = { altText: '', iconPath: '' };
	unreadNotificationPath: Image = {
		altText: 'Unread Notifications',
		iconPath: Icons.unreadNotifications
	};
	userName = '';
	payload:SubmitTnc ={
		id: '',
		creationDate: 0,
		company: ''
	};
	loading: boolean = false;
	businessAccountRegistrationSuccess : BusinessAccountRegistrationSuccess = ShellFactory.buildBusinessAccountRegistrationSuccessModal();
	adminLocations: Location[] = [];
	adminLocationList = new BehaviorSubject<Location[]>([]);
	adminLocationList$ = this.adminLocationList.asObservable();
	requestServiceUrl = new BehaviorSubject<string>('');
	requestServiceUrl$ = this.requestServiceUrl.asObservable();
	reminderModalState: ModalState = ShellFactory.buildReminderModal();
	reminderModalDesc: string = '';
	multipleRoleModalDesc: string = '';
	assignedRoles: AssignedRoles|null = ShellFactory.buildAssignedRoles();
	swtichRoleSuccess = new BehaviorSubject<boolean>(false);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	switchRoleResponse: any = '';
	multipleRoleToastMsg: MultipleRoleToastMsg = ShellFactory.buildMulRoleToastMsg();
	multipleRoleOptions: MultipleRoleOptions[] = [];
	get state(): KngShellState
	{
		return this.state$.value;
	}
	get stateObservable$(): Observable<KngShellState>
	{
		return this.state$.asObservable();
	}
	constructor( private readonly routerservice: Router, public apiService: ApiService, private readonly aemApiService: AemApiService, public sharedService:SharedService, public sharedUtilService:SharedUtilService, public sharedApiService:SharedApiService, public localStorageService: LocalStorageService,
		@Inject(expEnvironmentRef) readonly environmentRef: EnvironmentRef, private readonly logger: LoggerService, public toaster: ToastrService, private authService: AuthService) { }
	public updateState(value: KngShellState): void
	{
		this.state$.next(value);
	}
	public updateActionFooterPresent(isPresent: boolean): void
	{
		this.state.footer.cssClass = isPresent ? 'shell--with-action-button' : '';
		this.updateState(this.state);
	}
	public changeRoute(path: string)
	{
		this.routerservice.navigate([path])?.catch(error =>
		{
			this.logger.error(error);
		});
	}
	public updateBannerState(value: Banner)
	{
		this.state.banner = value;
	}
	public getAdminLocationList()
	{
		let adminId: string = '';
		this.bannerState.alertBanner = [];
		this.sharedService.getLoggedInUserAdminLocationIdObs().subscribe(adminLocID => adminId = adminLocID);
		this.apiService.getAdminLocationList().subscribe(
			{
				next: (res: ApiResponse) =>
				{
					if (res?.data)
					{
						const adminLocations = <KngHeaderNavMenuOption>res.data;
						if(adminLocations?.locations)
						{
							adminLocations.locations.sort((a: { accountName: string }, b: { accountName: string }) => a.accountName?.localeCompare(b.accountName));
							adminLocations.locations.forEach(location =>
							{
								if (location.locationGRID === adminId)
									location.adminId = true;
								else
									location.adminId = false;
							});
							this.adminLocations = [];
							adminLocations.locations.forEach(location =>
							{
								if (location.accountName)
									this.adminLocations.push(location);
							});
							this.adminLocationList.next(this.adminLocations);
						}
					}
				},
				error: (error) =>
				{
					this.toaster.error(error.error.message);
				}
			}
		);
	}
	public switchAccount(switchAccountPayload : SwitchAccountPayload)
	{
		this.apiService.switchAccount(switchAccountPayload).subscribe(
			{
				next: (res: ApiResponse) =>
				{
					if (res?.data)
					{
						this.loading = false;

						this.clearLocalStorageExceptAlertBanner();
						const path: string = this.environmentRef.baseUrl + urlPaths.myfleetSearch;
		                const key: string = btoa(JSON.stringify({ url: path }));
		   				this.localStorageService.removeCached(key);
						this.routerservice.navigate(['/auth']);
					}
				},
				error: (error) =>
				{
					this.loading = false;
					this.toaster.error(error.error.message);
				}
			}
		);
	}
	clearLocalStorageExceptAlertBanner()
	{
		const keys = Object.keys(localStorage);
		keys.forEach((key) =>
		{
			if (key !== 'headerAlertBanner')
			{
				localStorage.removeItem(key);
			}
		});
	}
	public async getHeaderNavState(hideServiceHistory: boolean)
	{
		let res: HeaderNavResponse;
		const checkHeaderNav = (this.sharedUtilService.isTmhCustomerSupportRole || this.sharedUtilService.isTmhCorporateAdmin) && !this.localStorageService.getCustomerToDashboard() ;
		this.aemApiService.getHeaderNavValues(checkHeaderNav).subscribe((response: ApiResponse) =>
		{
			if (response?.data)
			{
				res = <HeaderNavResponse>response.data;
				this.requestServiceUrl.next(res.requestServiceUrl);
				res?.globalHeader?.forEach((item: KngHeaderNavMenuOption) =>
				{
					if(item.iconPath)
						item.iconPath = this.aemBaseUrl + item.iconPath;
					this.handleGlobalHeader(item);
				});
				res?.mobileHeader.items.forEach((item: KngHeaderNavMenuOption) =>
				{
					if(item.iconPath)
						item.iconPath = this.aemBaseUrl + item.iconPath;
					this.handleMobileHeader(item, hideServiceHistory);
				});
				res?.portalHeader.forEach((item: KngHeaderNavMenuOption) =>
				{
					if(item.label === 'Service and Repairs')
					{
						item.hideMenu = hideServiceHistory;
					}
				});
				this.shellStateHeaderNavMapperObject.filter((elem) => elem.cssClass === CssClass.global)[0].menu = res?.globalHeader;
				this.shellStateHeaderNavMapperObject.filter((elem) => elem.cssClass === CssClass.portal)[0].menu = res?.portalHeader;
				this.shellStateHeaderNavMapperObject.filter((elem) => elem.cssClass === CssClass.mobile)[0].menu = res?.mobileHeader?.items;
				this.checkIfMinimumAccessProvided();
				this.state.header = this.shellStateHeaderNavMapperObject;
				this.state.isMyInSights = res.isMyInSights;
				this.updateState(this.state);
				if(!this.sharedUtilService.isTmhCorporateAdmin)
				{
					this.sharedApiService.getUnreadNotificationsCount();
				}
			}
		});
	}
	private handleGlobalHeader(item: KngHeaderNavMenuOption)
	{
		if (/cart/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.shop;
		}
		else if (/notify/i.exec(item.iconPath))
		{
			this.notificationPath = {
				altText: item.altText,
				iconPath: item.iconPath
			};
			item.cssClass = CssClass.notification;
		}
		else if (/mytoyota/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.logos;
			item.url = 'app/dashboard';
			this.isBusinessAccountHeader(item);
		}
		else if (/settings/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.user;
			this.sharedService.getuserNameObs().subscribe((res:string) =>
			{
				this.sharedService.updatedUserNameState = res;
				this.customerSupportData.username = res;
				item.label = res;
			});
		}
		else if (/location/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.locationListDropdown;
			item.dropdownArrow = { iconPath: Icons.chevronDownDesk, altText: '' };
			item.locations = this.adminLocations;

		}
	}
	private handleMobileHeader(item: KngHeaderNavMenuOption, hideMenu: boolean = false)
	{
		if (/shop-mobile/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.shopMobile;
		}
		if (/mytoyota/i.exec(item.iconPath))
		{
			item.cssClass = CssClass.shopMobile;
			item.url = 'app/dashboard';
			this.isBusinessAccountHeader(item);
		}
		if (/ACCOUNT MANAGER/i.exec(item.label))
		{
			item.cssClass = CssClass.locationListDropdown;
			item.dropdownArrow = { iconPath: Icons.chevronDown, altText: '' };
			item.locations = this.adminLocations;
		}
		if (/Service/i.exec(item.label))
		{
			item.hideMenu = hideMenu;
		}
	}
	isBusinessAccountHeader(item: KngHeaderNavMenuOption)
	{
		if(this.sharedUtilService.isTmhCorporateAdmin)
		{
			item.url = '';
			item.notClickable = true;
		}
	}
	checkIfMinimumAccessProvided()
	{
		
		{
			this.shellStateHeaderNavMapperObject.forEach(section =>
			{
				if(this.sharedUtilService.isTmhCorporateAdmin && !this.localStorageService.getCustomerToDashboard())
				{
					section.minimumAccess = true;
				}
				else
				{
					section.minimumAccess = false;
				}
			});
		}
	}
	public getFooterData(): void
	{
		this.aemApiService.getFooterData().subscribe((res: ApiResponse) =>
		{
			const data = res.data as { unifiedFooter: string; css: { ecomm: string }; script: {} };
			this.state.footer.footercontent.unifiedFooter = data.unifiedFooter;
			this.state.footer.footercontent.css.ecomm = data.css.ecomm;
			this.state.footer.footercontent.script = data.script;
			this.aemApiService.loadFooterStyles(this.state.footer.footercontent.css.ecomm);
			this.aemApiService.loadFooterScripts(this.state.footer.footercontent.script);
		});
	}
	public getAEMdetailsTerms(): void
	{
		this.apiService.getAEMdetailsTerms().subscribe((res: ApiResponse) =>
		{
			if(res?.data)
			{
				const data = <AemLabelsTnC>res.data;
				this.termsAndCondition.label= data.updatedTerms.heading;
				this.termsAndCondition.checkboxText = data.updatedTerms.checkboxText;
				if(this.termsAndCondition.tooltip)
				{
					this.termsAndCondition.tooltip.content = data.updatedTerms.infoIcon[0].altText;
				}
				this.termsAndCondition.buttons[1].label = data.updatedTerms.agreeButtonLabel;
				this.termsAndCondition.buttons[1].id = ModalButtonId.agree;
				this.termsAndCondition.buttons[0].label = data.updatedTerms.disagreeButtonLabel;
				this.termsAndCondition.buttons[0].id = ModalButtonId.cancel;
				this.termsAndConditionAEMlabels.updatedTerms = data.updatedTerms;
				this.termsAndConditionAEMlabels.updatedTerms.creationDate = data.updatedTerms.creationDate;
				this.termsAndConditionAEMlabels.updatedTerms.checkboxText = data.updatedTerms.checkboxText? data.updatedTerms.checkboxText : '';
				this.termsAndConditionAEMlabels.updatedTerms.alertNote = data.updatedTerms.alertNote ? data.updatedTerms.alertNote : TermsAndConditionPrivacyPolicyInfoBannerText.tandCInfoBannerText;
			}
		});
	}
	public submitTnC(payload:SubmitTnc): void
	{
		const currentDate = new Date();
		const unixTimestamp = Math.floor(currentDate.getTime());
		payload.creationDate = this.termsAndConditionAEMlabels.updatedTerms.creationDate;
	  payload.id = this.sharedService.getUserId();
	  this.sharedService.getLoggedInUserCompanyObs().pipe(tap((companyId: string) =>
		{
			payload.company = companyId;
		}),
		concatMap(() =>this.apiService.submitTnC(payload))).subscribe((res) =>
		{
			if(res)
			{
				this.termsAndCondition.hidden = true;
				const userProfile = this.localStorageService.getLoggedInUser();
				if(userProfile)
				{
					const user:LoggedInUser = <LoggedInUser> this.localStorageService.parseJSON(userProfile);
					user.tcDate = unixTimestamp;
					user.tncUpdated = false;
					this.localStorageService.setLoggedInUser(this.localStorageService.striginifyJSON(user));
				}
			}
		});
	}
	public getAEMdetailsPolicy(): void
	{
		this.apiService.getAEMdetailsPolicy().subscribe((res: ApiResponse) =>
		{
			if(res?.data)
			{
				const data = <AemLabelsPolicy>res.data;
				this.policyState.label= data.updatedPrivacy.heading;
				this.policyState.checkboxText= data.updatedPrivacy.checkboxText;
				if(this.policyState.tooltip)
				{
					this.policyState.tooltip.content = data.updatedPrivacy.infoIcon[0].altText;
				}
				this.policyState.buttons[1].label = data.updatedPrivacy.agreeButtonLabel;
				this.policyState.buttons[1].id = ModalButtonId.agree;
				this.policyState.buttons[0].label = data.updatedPrivacy.disagreeButtonLabel;
				this.policyState.buttons[0].id = ModalButtonId.cancel;
				this.policyAEMlabels.updatedPrivacy = data.updatedPrivacy;
				this.termsAndConditionAEMlabels.updatedTerms.creationDate = data.updatedPrivacy.creationDate;
				this.policyAEMlabels.updatedPrivacy.checkboxText = data.updatedPrivacy.checkboxText? data.updatedPrivacy.checkboxText : '';
				this.policyAEMlabels.updatedPrivacy.alertNote = data.updatedPrivacy.alertNote ? data.updatedPrivacy.alertNote : TermsAndConditionPrivacyPolicyInfoBannerText.privacyPolicyInfoBannerText;
			}
		});
	}
	public submitPolicy(payload:SubmitTnc): void
	{
		const currentDate = new Date();
		const unixTimestamp = Math.floor(currentDate.getTime());
		payload.creationDate = this.policyAEMlabels.updatedPrivacy.creationDate;
		payload.id = this.sharedService.getUserId();
		this.sharedService.getLoggedInUserCompanyObs().pipe(tap((companyId: string) =>
		{
			payload.company = companyId;
		}),
		concatMap(() =>this.apiService.submitPolicy(payload))).subscribe((res) =>
		  {
			if(res)
			{
				this.policyState.hidden = true;
				const userProfile = this.localStorageService.getLoggedInUser();
				if(userProfile)
				{
					const user:LoggedInUser = <LoggedInUser>this.localStorageService.parseJSON(userProfile);
					user.privacyDate = unixTimestamp;
					user.privacyPolicyUpdated = false;
					this.localStorageService.setLoggedInUser(this.localStorageService.striginifyJSON(user));
				}
			}
		  });
	  }
	public getGoogleTranslatePanel(renderer: Renderer2): HTMLIFrameElement | null
	{
		try
		{
			return renderer.selectRootElement('div.skiptranslate > iframe');
		}
		catch (error)
		{
			this.logger.log('trying to select google translate panel', error);
			return null;
		}
	}
	public performFirstTimeTranslation(selection: string, renderer: Renderer2): void
	{
		const googleTranslateMenuLink: HTMLAnchorElement = renderer.selectRootElement('#google_translate_element a');
		renderer.removeAttribute(googleTranslateMenuLink, 'href');
		renderer.selectRootElement(googleTranslateMenuLink).click();
		const iframeElList: NodeListOf<HTMLIFrameElement> = document.querySelectorAll('iframe.skiptranslate');
		const foundLink: unknown = Array.from(iframeElList).find((item: HTMLIFrameElement) =>
		{
			const links: NodeListOf<HTMLAnchorElement> | undefined = item.contentWindow !== null ? item.contentWindow.document.querySelectorAll('a') : undefined;
			const link: HTMLAnchorElement | undefined = links !== undefined ? Array.from(links).find(thisLink => lodashGet(thisLink, 'value') === selection) : undefined;
			link !== undefined ? renderer.selectRootElement(link).click() : (() => {} )();
			return link !== undefined;
		});
		this.logger.log('found translation link and stopped', foundLink);
	}
	public performSubsequetTranslation(panelAfterFirstTranslation: HTMLIFrameElement, selection: string): void
	{
		const buttonRestore: HTMLButtonElement | null = (panelAfterFirstTranslation.contentWindow as {document: Document}).document.getElementById(':2.restore') as HTMLButtonElement || null;
		const buttonTranslate: HTMLButtonElement | null = (panelAfterFirstTranslation.contentWindow as {document: Document}).document.getElementById(':2.confirm') as HTMLButtonElement || null;
		selection === 'en' ? (buttonRestore).click() : (buttonTranslate).click();
	}
	public getBusinessAccountSuccessLabels()
	{
		this.aemApiService.getBusinessAccountSuccessPopupLabels().subscribe((response: ApiResponse) =>
		{
			const responseObj: BusinessAccountRegistrationSuccessLabels = <BusinessAccountRegistrationSuccessLabels> response.data;
			this.businessAccountRegistrationSuccess.congratulationsImage.altText = responseObj.congratulationsImage.altText;
			this.businessAccountRegistrationSuccess.mainText = responseObj.mainText;
			this.businessAccountRegistrationSuccess.subText = responseObj.subText;
			this.businessAccountRegistrationSuccess.modal.buttons[0].label = responseObj.closeButtonLabel;
		});
	}
	public getHeaderAlertBanner()
	{
		const storedBanner = localStorage.getItem('headerAlertBanner');
		if (!storedBanner)
		{
			this.aemApiService.getHeaderAlertBanner().subscribe((res: ApiResponse) =>
			{
				if (res?.data)
				{
					const data: HeaderAlertBanner = <HeaderAlertBanner>res.data;
					localStorage.setItem('headerAlertBanner', JSON.stringify(data.alertBanner));
					this.updateStateAlertBanner(data.alertBanner);
					this.updateDealerAlertBanner(true);
				}
			});
		}
		else
		{
			const data: AlertBannerList[] = JSON.parse(storedBanner);
			if (Array.isArray(data))
			{
				this.bannerState.alertBanner = [];
				this.updateStateAlertBanner(data);
				this.updateDealerAlertBanner(false);
			}
		}
	}
	private updateStateAlertBanner(alertBannerList: AlertBannerList[])
	{
		if (this.bannerState.alertBanner)
		{
			alertBannerList.forEach((val) =>
			{
				const currentDate = new Date().getTime();
				const endDisplay = new Date(val.endDate).getTime();
				const startDisplay = new Date(val.startDate).getTime();

				const display = currentDate > startDisplay &&  currentDate < endDisplay ? val.display : 'false';
				const banner: AlertBanner = {
					display: display,
					bannerIcon: val.bannerIcon,
					closeIcon: val.closeIcon,
					bannerMessage: this.updateHeaderAlertBanner(val),
					hasTokenInMessage: val.hasTokenInMessage,
					tokenDataList: val.tokenData,
					startDate: val.startDate,
					endDate: val.endDate,
					showModal: val.showModal ?? false
				};
				this.bannerState.alertBanner?.push(banner);
			});
		}
	}
	public updateHeaderAlertBanner(res: AlertBannerList): string
	{
		const bannerDataMessage = this.sharedService.updateServiceCampaignBannerDataValue
		(
			res.bannerMessage, res.tokenData
		);
		return bannerDataMessage;
	}
	public updateDealerAlertBanner(updateBanner: boolean, showBanner?: boolean)
	{
		const userDetails = this.localStorageService.getLoggedInUser();
		if(userDetails)
		{
			const user:LoggedInUser = <LoggedInUser> this.localStorageService.parseJSON(userDetails);
			this.apiService.getShellData().subscribe({
				next: (res: ShellData) => 
				{
					if (res) 
					{
						if(user.addLocationsBanner)
						{
							this.reminderModalState.label = res.remindModal.title;
							this.reminderModalDesc = res.remindModal.description;
							this.reminderModalState.buttons[0].label = res.remindModal.no;
							this.reminderModalState.buttons[1].label = res.remindModal.yes;
							if(updateBanner)
							{
								const banner: AlertBanner = {
									display: 'true',
									bannerIcon: res.bannerData.bannerIcon,
									closeIcon: res.bannerData.bannerIcon,
									bannerMessage: this.sharedService.updateServiceCampaignBannerDataValue
									(
										res.bannerData.bannerMessage, res.bannerData.tokenData
									),
									hasTokenInMessage: '',
									tokenDataList: res.bannerData.tokenData,
									startDate: new Date(),
									endDate: new Date(res.bannerData.endDate),
									showModal: res.bannerData.showModal
								};
								this.bannerState.alertBanner?.push(banner);
								localStorage.setItem('headerAlertBanner', JSON.stringify(this.bannerState.alertBanner));
							}
						}
						const isBannerDismissed = localStorage.getItem('reviewListBannerClosed');
						if(isBannerDismissed)
						{
							this.reviewListBannerState.open = false;
							return;
						}
						else if (showBanner)
						{
							this.reviewListBannerState.open=true;
							this.reviewListBannerState.bannerMessage = res.reviewListBanner.reviewlistBannerMessage;
							this.reviewListBannerState.bannerIcon = res.reviewListBanner.bannerIcon;
							this.reviewListBannerState.closeIcon = res.reviewListBanner.closeIcon;
						}
					}
				}
			});
			
		}
	}
	
	resetToDefaultAccount()
	{
		const defaultGrid: string = this.sharedService.getDefaultGrid();
		const switchAccountPayload : SwitchAccountPayload = { selectedLocation: defaultGrid };
		this.loading = true;
		return new Observable((observer: Observer<ApiResponse>) =>
		{
			this.apiService.switchAccount(switchAccountPayload).subscribe({
				next: (response) =>
				{
					this.loading = false;
					observer.next(response);
					observer.complete();
				},
				error: (error) =>
				{
					this.loading = false;
					observer.error(error);
				}
			});
		});
	}
	getCustomerAemLabels()
	{
		const customerLabel = this.localStorageService.getCustomerAemLabels();
		if(customerLabel !== null && customerLabel !== undefined)
		{
			const labels: CustomerSupportAemLabel = <CustomerSupportAemLabel>this.localStorageService.parseJSON(customerLabel);
			this.mapCustomerlabels(labels);
		}
		else
		{
			this.apiService.getCustomerSupportLabels().subscribe({
				next: (response: ApiResponse) =>
				{
					if (response)
					{
						const responseObj = <CustomerSupportAemLabel>response.data;
						this.localStorageService.setCustomerAemLabels(JSON.stringify(responseObj));
						this.mapCustomerlabels(responseObj);
					}
				},
				error: (error) =>
				{
					this.toaster.error(error?.error?.message);
				}
			});
		}
	}
	mapCustomerlabels(res: CustomerSupportAemLabel): void
	{
		this.customerSupportData.readOnly = this.sharedService.emptyStringHandler(res.readOnly);
		this.customerSupportData.warningNote = this.sharedService.emptyStringHandler(res.warningNote);
		this.customerSupportData.endSessionNote = this.sharedService.emptyStringHandler(res.endSessionNote);
		this.customerSupportData.endSession = this.sharedService.emptyStringHandler(res.endSession);
		this.endSessionModalState.label = this.sharedService.emptyStringHandler(res.endSession);
		this.endSessionModalState.buttons[0].label = this.sharedService.emptyStringHandler(res.endSessionCta);
		this.endSessionModalState.buttons[1].label = this.sharedService.emptyStringHandler(res.continueSessionCta);
		this.inactiveSessionModalState.label = this.sharedService.emptyStringHandler(res.inActivityAlert);
		this.inactiveSessionModalState.buttons[0].label = this.sharedService.emptyStringHandler(res.endSession);
		this.inactiveSessionModalState.buttons[1].label = this.sharedService.emptyStringHandler(res.continueSession);
		this.customerSupportData.inactivityConfirmation = this.sharedService.emptyStringHandler(res.inActivityConfirmation);
		this.customerSupportData.inativityMessage = this.sharedService.emptyStringHandler(res.inActivityMessage);
		this.customerSupportData.hidden = !((this.sharedUtilService.isTmhCustomerSupportRole || this.sharedUtilService.isTmhCorporateAdmin) && this.localStorageService.getCustomerToDashboard());
		this.routerservice.events.subscribe((event) =>
		{
			if(event instanceof NavigationStart)
			{
				if(event.url.includes('customer-support'))
				{
					this.customerSupportData.hidden = true;
				}
			}
		});
	}
	endImpersonationSession()
	{
		this.customerSupportData.hidden = true;
		this.localStorageService.setCustomerToDashboard('false');
		this.sharedUtilService.isCustomerSupportSession$.next(false);
		this.localStorageService.removeImpersonateUser();
		this.localStorageService.setUserName('');
		localStorage.removeItem('reviewListBannerClosed');
		this.reviewListBannerState.open=false;
		if(this.sharedUtilService.isTmhCorporateAdmin)
		{
			localStorage.setItem('endCorpSession', 'true');
			this.routerservice.navigate(['/app/customerportal']);
		}
		else
		{
			this.routerservice.navigate(['/app/customer-support']);
		}
	}
	async getServiceCount(): Promise<boolean>
	{
		try
		{
			const response: ApiResponse = await firstValueFrom(this.apiService.getServiceHistoryCount());
			const resp = <{ totalRecords: number }>response.data;
			return resp.totalRecords > 0 ? false : true;
		}
		catch (error)
		{
			return false;
		}
	}
	confirmModalClose()
	{
		const payload: UserPreferncePayload = {
			type: 'HIDE_LOCATIONS_SETUP_BANNER'
		};
		this.apiService.removeReminder(payload).subscribe({
			next: (response: ApiResponse) =>
			{
				if (response)
				{
					this.reminderModalState.hidden = true;
				}
			},
			error: (error) =>
			{
				this.toaster.error(error?.error?.message);
			}
		});
	}

	getAssignedRole<T>(): T | null 
	{
		const item = this.localStorageService.getAssignedRoles();
		return item && item !== 'undefined' ? JSON.parse(item) as T : null;
	}

	multipleRoleModal()
	{
		this.apiService.getShellData().subscribe({
			next: (res: ShellData) =>
			{
				if(res)
				{
					this.multipleRoleModalState.label = res.multipleRoleModal?.label;
					this.multipleRoleModalState.buttons[0].label = res.multipleRoleModal?.buttons[0]?.label;
					this.multipleRoleModalState.buttons[1].label = res.multipleRoleModal?.buttons[1]?.label;
					this.multipleRoleModalDesc = res.modalLabel;
					this.multipleRoleToastMsg.corpAdminTstMsg = res.corpAdminTstMsg;
					this.multipleRoleToastMsg.accMngTstMsg = res.accMngTstMsg;
					this.multipleRoleToastMsg.csrTstMsg = res.csrTstMsg;
					this.assignedRoles = this.getAssignedRole();
					this.multipleRoleOptions = res.multipleRoleOptions;
					const assignedRoleIds = Object.values(this.assignedRoles ?? {}).filter(Boolean);
					this.multipleRoleOptions = (this.multipleRoleOptions ?? []).filter(option =>
						assignedRoleIds.includes(option.id)
					);
				}
			}
		});
	}

	switchUserRole(payload: SwitchRole, showToast: boolean = true)
	{
		this.apiService.switchRole(payload).subscribe({
			next: (res: ApiResponse) =>
			{
				this.switchRoleResponse = res.data;
				if(this.switchRoleResponse.statusCode === 200)
				{
					this.swtichRoleSuccess.next(false);
					if(showToast)
					{
						this.toaster.error(this.switchRoleResponse.message);
					}
					sessionStorage.removeItem('switchRole');
					this.loading = false;
				}
				else if(this.switchRoleResponse.statusCode === 201)
				{
					this.swtichRoleSuccess.next(true);
				}
			},
			error: (error: HttpErrorResponse) =>
			{
				this.toaster.error(error.error.message, '', {
					timeOut: 2000
				});
				this.swtichRoleSuccess.next(false);
				this.loading = false;
			}
		});
	}
}
